import { AdminRescueService } from "../../../services/admin-rescue.service.js";

export const RescueTab = async (container) => {
    container.innerHTML = `
        <div class="space-y-6">
            <div class="bg-white p-6 rounded-xl border border-rose-200 shadow-sm">
                <div class="flex items-center gap-3 mb-4">
                    <span class="p-2 bg-rose-100 text-rose-600 rounded-lg">
                        <span class="material-symbols-outlined">medical_services</span>
                    </span>
                    <div>
                        <h3 class="text-lg font-bold text-gray-900">Emergency Rescue & Recovery</h3>
                        <p class="text-sm text-gray-500">Repair compromised series data and fix ownership issues.</p>
                    </div>
                </div>

                <!-- Diagnosis Section -->
                <div class="mb-8">
                    <h4 class="font-bold text-gray-800 mb-3 flex items-center gap-2">
                        <span class="material-symbols-outlined text-indigo-500">bug_report</span> 1. Diagnose Series
                    </h4>
                    <div class="flex gap-4 mb-4">
                        <input type="text" id="rescue-series-id" placeholder="Enter Series ID" class="flex-1 p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-rose-500 focus:border-rose-500 outline-none transition-all font-mono text-sm">
                        <button id="btn-diagnose" class="px-6 py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-bold rounded-lg transition-colors flex items-center gap-2">
                            <span class="material-symbols-outlined">search</span> Diagnose
                        </button>
                    </div>
                    <pre id="diagnosis-result" class="bg-gray-900 text-green-400 p-4 rounded-lg text-xs font-mono overflow-x-auto min-h-[100px] hidden"></pre>
                </div>

                <div class="h-px bg-gray-200 my-6"></div>

                <!-- Repair Section -->
                <div>
                    <h4 class="font-bold text-gray-800 mb-3 flex items-center gap-2">
                        <span class="material-symbols-outlined text-rose-500">build</span> 2. Repair Series
                    </h4>
                    <div class="bg-rose-50 border border-rose-100 p-4 rounded-lg mb-4">
                        <p class="text-sm text-rose-700 font-bold mb-2"><span class="material-symbols-outlined align-bottom text-base">warning</span> Safety Check</p>
                        <p class="text-xs text-rose-600">This action will modify database records. Ensure you simply checked the diagnosis first.</p>
                    </div>

                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                        <div>
                            <label class="block text-xs font-bold text-gray-500 mb-1">Target Series ID</label>
                            <input type="text" id="repair-series-id" placeholder="Series ID to Repair" class="w-full p-3 border border-gray-300 rounded-lg bg-gray-50 font-mono text-sm" readonly>
                        </div>
                        <div>
                            <label class="block text-xs font-bold text-gray-500 mb-1">Correct Author ID (Required)</label>
                            <input type="text" id="repair-author-id" placeholder="Original Author UID" class="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-rose-500 outline-none font-mono text-sm">
                        </div>
                    </div>

                    <button id="btn-repair" class="w-full py-4 bg-rose-600 hover:bg-rose-500 text-white font-bold rounded-xl shadow-lg shadow-rose-200 transition-all active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed" disabled>
                        EXECUTE REPAIR (Restores Ownership & Migrates Chapters)
                    </button>
                </div>
            </div>

            <!-- Log Console -->
            <div class="bg-black text-white p-6 rounded-xl font-mono text-xs h-[300px] overflow-y-auto" id="rescue-console">
                <div class="text-zinc-500 border-b border-zinc-800 pb-2 mb-2">System Console Ready...</div>
            </div>
        </div>
    `;

    // Elements
    const inputSeriesId = container.querySelector('#rescue-series-id');
    const btnDiagnose = container.querySelector('#btn-diagnose');
    const resultPre = container.querySelector('#diagnosis-result');

    const inputRepairSeriesId = container.querySelector('#repair-series-id');
    const inputRepairAuthorId = container.querySelector('#repair-author-id');
    const btnRepair = container.querySelector('#btn-repair');
    const consoleDiv = container.querySelector('#rescue-console');

    // Utility: Logger
    const log = (msg, type = 'info') => {
        const line = document.createElement('div');
        const ts = new Date().toLocaleTimeString();
        line.className = `mb-1 ${type === 'error' ? 'text-red-400' : (type === 'success' ? 'text-green-400' : 'text-zinc-300')}`;
        line.innerHTML = `<span class="text-zinc-600">[${ts}]</span> ${msg}`;
        consoleDiv.appendChild(line);
        consoleDiv.scrollTop = consoleDiv.scrollHeight;
    };

    // Handler: Diagnose
    btnDiagnose.onclick = async () => {
        const seriesId = inputSeriesId.value.trim();
        if (!seriesId) return window.Modal.toast("Please enter Series ID");

        btnDiagnose.disabled = true;
        btnDiagnose.innerHTML = '<span class="animate-spin material-symbols-outlined">sync</span> Checking...';
        resultPre.classList.remove('hidden');
        resultPre.textContent = "Fetching data...";
        log(`Starting diagnosis for ${seriesId}...`);

        try {
            const result = await AdminRescueService.diagnoseSeries(seriesId);
            resultPre.textContent = JSON.stringify(result, null, 2);
            log("Diagnosis Complete.", 'success');

            // Populate Repair Fields
            inputRepairSeriesId.value = seriesId;
            if (result.authorId) {
                // If corrupted, this might be Admin ID. But we put it there anyway to change.
                inputRepairAuthorId.placeholder = `Current: ${result.authorId}`;
            }
            btnRepair.disabled = false;

            if (result.migrationNeeded) {
                log(`[ALERT] Migration Needed: ${result.legacyChapterCount} chapters found in legacy array.`, 'error');
            }
            if (result.status === "Likely Compromised") {
                log(`[ALERT] Ownership seems compromised (Admin Role found).`, 'error');
            }

        } catch (e) {
            log(`Diagnosis Failed: ${e.message}`, 'error');
            resultPre.textContent = "Error: " + e.message;
        } finally {
            btnDiagnose.disabled = false;
            btnDiagnose.innerHTML = '<span class="material-symbols-outlined">search</span> Diagnose';
        }
    };

    // Handler: Repair
    btnRepair.onclick = async () => {
        const seriesId = inputRepairSeriesId.value.trim();
        const authorId = inputRepairAuthorId.value.trim();

        if (!seriesId) return window.Modal.toast("No Series selected");
        if (!authorId) return window.Modal.toast("Please enter the Correct Author ID");

        if (!confirm(`Are you SURE you want to repair Series ${seriesId}?\n\n- Helper: Restore Author to ${authorId}\n- Action: Migrate Chapters to Subcollection`)) return;

        btnRepair.disabled = true;
        btnRepair.innerHTML = '<span class="animate-spin material-symbols-outlined">build</span> Repairing...';
        log(`Starting Repair Operation...`, 'info');

        try {
            const success = await AdminRescueService.repairSeries(seriesId, authorId);
            if (success) {
                log("Repair Operation Completed Successfully!", 'success');
                window.Modal.alert("Repair Complete. Please verify via Diagnose.");
                // Clear Form? No, let them re-diagnose.
                btnRepair.innerHTML = 'REPAIR COMPLETE';
            }
        } catch (e) {
            log(`Repair Failed: ${e.message}`, 'error');
            window.Modal.alert("Repair Failed: " + e.message);
            btnRepair.disabled = false;
            btnRepair.innerHTML = 'EXECUTE REPAIR';
        }
    };
};
